import { Box, IconButton, Stack, Typography } from '@mui/material';
import { Trash2 } from 'lucide-react';
import { ReactNode } from 'react';
import { ICON_PX } from '~/theme/iconSizes';

interface StepRowProps {
    letter?: string;
    /** Removes the row; a row without it keeps the column, empty. */
    onRemove?: () => void;
    removeLabel?: string;
    children: ReactNode;
}

/**
 * One row of the operation chain: its letter, its controls, and a remove
 * button in a fixed column, so the controls of every row line up.
 */
export default function StepRow({
    letter,
    onRemove,
    removeLabel,
    children,
}: StepRowProps) {
    return (
        <Box
            display="grid"
            gridTemplateColumns="8px minmax(0, 1fr) 24px"
            alignItems="center"
            gap={1}
        >
            <Typography variant="monoMeta">{letter}</Typography>
            <Stack direction="row" alignItems="center" gap={1} minWidth={0}>
                {children}
            </Stack>
            {onRemove && (
                <IconButton
                    size="small"
                    color="error"
                    onClick={onRemove}
                    aria-label={removeLabel}
                >
                    <Trash2 size={ICON_PX} />
                </IconButton>
            )}
        </Box>
    );
}
